export namespace ContactSectorsStatic {
  export interface ContactSector {
    id: number;
    name: string;
  }

  export enum ContactSectorSearchParameters { name = 'name' }
}
